// extracted by mini-css-extract-plugin
module.exports = {"tableRow":"list-item-skeleton_tableRow__dbYyH","icon":"list-item-skeleton_icon__kHCwG","tableCell":"list-item-skeleton_tableCell__3pjoj"};